import classNames from 'classnames'
import React, { FC, useEffect, useRef, useState } from 'react'
import { useTranslations } from '../hooks/useTranslations'
import { VideoButton, VideoButtonSize } from './VideoButton'

export interface SoundButtonProps {
  active: boolean
  onClick: () => void
  size?: VideoButtonSize
}

export const SoundButton: FC<SoundButtonProps> = ({ active, ...videoButtonProps }) => {
  const translations = useTranslations()
  const [animationActive, setAnimationActive] = useState(active)
  const spanRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (active) {
      setAnimationActive(true)
    } else if (spanRef.current) {
      const span = spanRef.current

      const callback = () => {
        setAnimationActive(false)
      }

      span.addEventListener('animationiteration', callback)

      return () => {
        span.removeEventListener('animationiteration', callback)
      }
    }
  }, [active])

  const commonSpanClassName = 'w-[2px] h-full transform scale-x-150 bg-neutral'

  return (
    <VideoButton
      {...videoButtonProps}
      title={(active ? translations.turnOffSound : translations.turnOnSound) ?? ''}
    >
      <div className="flex items-center h-full gap-[3px]">
        <span
          className={classNames(commonSpanClassName, {
            'animate-[sound-button-wave1_0.4s_infinite]': animationActive,
            'scale-y-[61%]': !animationActive,
          })}
          ref={spanRef}
        ></span>
        <span
          className={classNames(commonSpanClassName, {
            'animate-[sound-button-wave2_0.4s_infinite]': animationActive,
            'scale-y-[100%]': !animationActive,
          })}
        ></span>
        <span
          className={classNames(commonSpanClassName, {
            'animate-[sound-button-wave3_0.4s_infinite]': animationActive,
            'scale-y-[64%]': !animationActive,
          })}
        ></span>
        <span
          className={classNames(commonSpanClassName, {
            'animate-[sound-button-wave4_0.4s_infinite]': animationActive,
            'scale-y-[89%]': !animationActive,
          })}
        ></span>
        <span
          className={classNames(commonSpanClassName, {
            'animate-[sound-button-wave5_0.4s_infinite]': animationActive,
            'scale-y-[57%]': !animationActive,
          })}
        ></span>
      </div>
    </VideoButton>
  )
}
